import { isEmpty } from 'lodash';
import { MdState } from 'platform-components/src/components/marker/types';
import React from 'react';
import { connect } from 'react-redux';

import { ProblemInfo } from 'store/problems/typings';

import * as selectors from '../selectors';

import ProblemViewInfo from './../__info/probem-view__info';
import SidePanel, { SidePanelProps } from './problem-view__side-panel';

interface StoreProps {
    info: ProblemInfo | null;
    mdState: MdState | null;
}

type Props = StoreProps & SidePanelProps;

export const InfoSidePanel = ({ info, mdState, ...sidePanelProps }: Props) => {
    if (!info || !mdState || isEmpty(info)) {
        return null;
    }

    return (
        <SidePanel {...sidePanelProps}>
            <ProblemViewInfo />
        </SidePanel>
    );
};

const mapStateToProps = (storeState: any): StoreProps => ({
    info: selectors.getProblemInfo(storeState),
    mdState: selectors.getProblemMdState(storeState),
});

export default connect(mapStateToProps)(InfoSidePanel);
